module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _vm._v("The History and Philosophy of Education Series")]), _vm._v(" "), _c('p', {
    staticClass: "sered",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("EDITED")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("RANDALL")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CURREN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("JONATHAN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ZIMMERMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "serf",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("COLOR")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MIND:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WHY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ORIGINS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ACHIEVEMENT")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("GAP")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MATTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("FOR")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("JUSTICE")]), _vm._v(" "), _c('i', [_vm._v("by Derrick Darby and John L. Rury")])]), _vm._v(" "), _c('p', {
    staticClass: "serf",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CASE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("FOR")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CONTENTION:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TEACHING")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CONTROVERSIAL")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISSUES")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AMERICAN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SCHOOLS")]), _vm._v(" "), _c('i', [_vm._v("by Jonathan Zimmerman and Emily Robertson")])]), _vm._v(" "), _c('p', {
    staticClass: "serf",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("HAVE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LITTLE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("FAITH:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("RELIGION,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DEMOCRACY,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AMERICAN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PUBLIC")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SCHOOL")]), _vm._v(" "), _c('i', [_vm._v("by Benjamin Justice and Colin Macleod")])]), _vm._v(" "), _c('p', {
    staticClass: "serf",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("TEACHING")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EVOLUTION")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CREATION")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("NATION")]), _vm._v(" "), _c('i', [_vm._v("by Adam Laats and Harvey Siegel")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e9287b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-curren-0003.vue
// module id = 60
// module chunks = 0